import './index.css';
import { useEffect } from 'react';
import { useRouteLocation, useLink } from 'react-router-stack';
import { ScreenBackground, Header, View, RouteWrapper } from '../../../component';

const PaytmPayment = () => {
  const location = useRouteLocation();
  const navigate = useLink();
  const {
    orderId,
    txnToken,
    // orderAmount: amount,
    mid,
    basePaymentUrl = ''
  } = location.state as any;
  useEffect(() => {
    setTimeout(() => {
      navigate.push('/paytm_callback');
    }, 10);
  }, []);

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={'Paytm Payment'} onClickBack={onClickBack} />
        <View className="paytm-payment-container">
          <iframe
            srcDoc={`<html>
        <head>
           <title>Show Payment Page</title>
        </head>
        <body>
           <center>
              <h1>Please do not refresh this page...</h1>
           </center>
                   <form target="popup" method="post" action="${basePaymentUrl}?mid=${mid}&orderId=${orderId}" name="paytm">
              <table border="1">
                 <tbody>
                    <input type="hidden" name="mid" value="${mid}]">
                    <input type="hidden" name="orderId" value="${orderId}">
                    <input type="hidden" name="txnToken" value="${txnToken}">
                 </tbody>
              </table>
              <script type="text/javascript"> document.paytm.submit(); </script>
           </form>
        </body>
     </html>`}
            allow="payment"
            width={'100%'}
            height={'100%'}
            seamless={true}
          />
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default PaytmPayment;
